import { Label, RadialBar, RadialBarChart, PolarGrid, PolarRadiusAxis } from "recharts";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  CardFooter
} from "../ui/card";
import {
  ChartContainer,
} from "../ui/chart";

export const description = "Camera Status";

export function CameraStatus(props) {
  const chartData = [
    {
      state: props.state,
      value: 100,
      fill: `${props.state?.toUpperCase() === "ON" ? "hsl(var(--chart-2))" : "hsl(var(--muted-foreground))"}`,
    },
  ];

  return (
    <Card className="flex flex-col min-h-[360px] max-h-[450px] w-full min-w-[250px] items-center">
      <CardHeader className="flex flex-col items-center pb-0 text-center">
        <CardTitle className="whitespace-normal break-words">Camera Status</CardTitle>
        <CardDescription>Live</CardDescription>
      </CardHeader>
      <CardContent className="flex-1 pb-0">
        <ChartContainer
          config={chartData}
          className="mx-auto aspect-square max-h-[250px] min-h-[200px]"
        >
          <RadialBarChart
            data={chartData}
            startAngle={0}
            endAngle={360}
            innerRadius={80}
            outerRadius={110}
            className="mt-10"
          >
            <PolarGrid
              gridType="circle"
              radialLines={false}
              stroke="none"
              className="first:fill-muted last:fill-background"
              polarRadius={[86, 74]}
            />
            <RadialBar dataKey="value" background cornerRadius={10} />
            <PolarRadiusAxis tick={false} tickLine={false} axisLine={false}>
              <Label
                content={({ viewBox }) => {
                  if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                    return (
                      <text
                        x={viewBox.cx}
                        y={viewBox.cy}
                        textAnchor="middle"
                        dominantBaseline="middle"
                      >
                        <tspan
                          x={viewBox.cx}
                          y={viewBox.cy}
                          className="fill-foreground text-4xl font-bold"
                        >
                          {props.state?.toUpperCase()}
                        </tspan>
                      </text>
                    );
                  }
                }}
              />
            </PolarRadiusAxis>
          </RadialBarChart>
        </ChartContainer>
      </CardContent>
      <CardFooter className="flex-col gap-2 text-sm">
      </CardFooter>
    </Card>
  );
}